import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';

@Component({
  selector: 'app-auth-email-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './auth-email-field.component.html',
  styleUrls: ['./auth-email-field.component.scss'],
})
export class AuthEmailFieldComponent {
  @Input({ required: true }) control!: FormControl<string>;
  @Input() placeholder = 'Email';
  @Input() invalidHint = 'Invalid email format';
  /** Tighter gap under field (e.g. verify-email modal) */
  @Input() compactErrorSpacing = false;

  get showError(): boolean {
    return this.control.invalid && this.control.touched;
  }
}
